import { RouteObject } from "react-router-dom";

export default [
  {
    index: true,
    lazy: () => import("modules/career/pages/CareerHome"),
  },
  {
    path: "openings",
    lazy: () => import("modules/career/pages/CareerOpenings"),
  },
  {
    path: "openings/create",
    lazy: () => import("modules/career/pages/CareerCreateUpdate"),
  },
  {
    path: "openings/:id/edit",
    lazy: () => import("modules/career/pages/CareerCreateUpdate"),
  },
  {
    path: "applications",
    lazy: () =>
      import("modules/career-application/pages/CareerApplicationList"),
  },
] as RouteObject[];
